import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import PrintSchemaForm from '../forms/print-schema-form';
import { printSchemaValidationSchema } from '../schema/printSchema.js';

export default function PrintSchemaNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Print Schema Node Details',
        altText: 'Print Schema Node',
        defaultLabel: data?.command || 'Print Schema Node',
        forceDefaultLabel: true,
      }}
    >
      <CommonNode FormComponent={PrintSchemaForm} schemaResolver={printSchemaValidationSchema} />
    </NodeProvider>
  );
}
